module.exports = __webpack_public_path__ + "ddb2bba616139a38f929102686132152.woff2";